export const getTextContent = (element) => {
  if (!element) return ''
  if (typeof element === 'string' || typeof element === 'number') return element
  if (Array.isArray(element)) return element.map(getTextContent).join(' ')
  if (element.props && element.props.children) return getTextContent(element.props.children)
  return ''
}
